module.exports = __webpack_public_path__ + "static/other-workshop-image-92f3e68d5be6bb2efd7eb0af6ef7a264.jpg";